import styled from "styled-components";

export const EarningsChartWrapper = styled.div`
  margin: 0;

  @media (min-width: 992px) {
    margin: 0 8%;
  }
`;
